import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { FlowAccountService } from './flow-account.service';

@Injectable({
    providedIn: 'root'
})
export class AuthenticatedGuard implements CanActivate {
    constructor(private accountService: FlowAccountService, private router: Router) {}

    canActivate(): boolean {
        if (this.accountService.isAuthenticated()) {
            this.router.navigateByUrl(`/${this.accountService.getTenant()}`);
            return false; 
        }
        return true; 
    }
}